/*
 * @Author: 代码尊 gaojianstyle@163.com
 * @Date: 2023-01-18 05:55:09
 * @LastEditors: gaojian
 * @LastEditTime: 2023-02-04 19:21:11
 * @FilePath: \g-vue3\src\main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'



// 导入element-plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// bootstrap
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"


// tailwindcss
import './index.css'
///////////////////
const app = createApp(App)
///////////////////

// 导入element-plus
app.use(ElementPlus)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}


app.use(store).use(router).mount('#app')


